import React, { useEffect } from 'react';
import './Notification.css';

const Notification = ({ message, show, type = 'success', onClose, duration }) => {
  const getNotificationDuration = (notificationType) => {
    switch (notificationType) {
      case 'error':
        return 6000;
      case 'warning':
        return 5000;
      case 'info':
        return 4000;
      case 'success':
        return 2500;
      default:
        return 3000;
    }
  };

  const finalDuration = duration || getNotificationDuration(type);

  useEffect(() => {
    if (show && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, finalDuration);

      return () => clearTimeout(timer);
    }
  }, [show, onClose, finalDuration]);

  const handleClick = () => {
    if (onClose) {
      onClose();
    }
  };

  if (!show || !message) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '✅';
    }
  };

  return (
    <div
      className={`notification notification--${type} show`}
      role="alert"
      onClick={handleClick}
      title="Tocá para cerrar"
    >
      <div className="notification__icon">{getIcon()}</div>
      <div className="notification__content">
        <div className="notification__message">{message}</div>
      </div>
    </div>
  );
};

export default Notification;
